@if (vm(); as vm) {
  <div class="sidebar-header_title">{{ 'TechnicalInfo' | transloco }}</div>

  <tt-divider />

  <div class="sidebar-header_details">
    <div class="sidebar-header_field">
      <span class="sidebar-header_label">{{ 'Version' | transloco }}</span>
      <span class="sidebar-header_value" data-testid="sidebar-header_guideline-version">{{ vm?.version ? vm?.version : '-' }}</span>
    </div>

    @if (vm.providerOrganisation?.displayName) {
      <div class="sidebar-header_field">
        <span class="sidebar-header_label">{{ 'ProviderOrganisation' | transloco }}</span>
        <span class="sidebar-header_value" data-testid="sidebar-header_provider-organisation">
          {{ vm?.providerOrganisation?.displayName ? vm?.providerOrganisation?.displayName : '-' }}
        </span>
      </div>
    }

    <div class="sidebar-header_field">
      <span class="sidebar-header_label">{{ 'GuidelineCode' | transloco }}</span>
      <span class="sidebar-header_value" data-testid="sidebar-header_guideline-code">{{ vm?.code ? vm?.code : '-' }}</span>
    </div>

    <div class="sidebar-header_field">
      <span class="sidebar-header_label">{{ 'Reviewer' | transloco }}</span>
      <span class="sidebar-header_value" data-testid="sidebar-header_reviewer">{{ vm.reviewer ? (vm.reviewer | name) : '-' }}</span>
    </div>

    <div class="sidebar-header_field">
      <span class="sidebar-header_label">{{ 'ApprovedDate' | transloco }}</span>
      <span class="sidebar-header_value" data-testid="sidebar-header_review-date">
        {{ vm?.approvedAt ? (vm.approvedAt | utcToLocal) : '-' }}
      </span>
    </div>

    <div class="sidebar-header_field">
      <span class="sidebar-header_label">{{ 'Publisher' | transloco }}</span>
      <span class="sidebar-header_value" data-testid="sidebar-header_publisher">{{ vm.publisher ? (vm.publisher | name) : '-' }}</span>
    </div>

    <div class="sidebar-header_field">
      <span class="sidebar-header_label">{{ 'PublishDate' | transloco }}</span>
      <span class="sidebar-header_value" data-testid="sidebar-header_publish-date">
        {{ vm?.publishedAt ? (vm.publishedAt | utcToLocal) : '-' }}
      </span>
    </div>
  </div>

  <tt-divider />

  <div class="sidebar-header_settings">
    <div class="sidebar-header_field">
      <span class="sidebar-header_label">{{ 'GuidelineLanguage' | transloco }}:</span>
      <app-language-picker
        class="guideline-language-picker"
        [currentLanguage]="vm.languageCode"
        [disabled]="isEditPage()"
        (languageChanged)="handleLanguageChanged($event)" />
    </div>

    <div class="sidebar-header_field">
      <span ttLabel>{{ 'MedicalCodes' | transloco }}:</span>
      <tt-coding-systems-selector [codings]="vm.codings" (codingsChanged)="handleCodingsChanged($event)" />
    </div>
  </div>
}
